import ReactDOM from "react-dom";

import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

interface IOverlayProperties {
  caption?: string;
  isVisible: boolean;
  title: string;
}

const Overlay = ({ caption, isVisible, title }: IOverlayProperties) => {
  if (!isVisible) {
    return;
  }
  const overlayRoot = document.querySelector("#overlay-root");

  if (!overlayRoot) {
    throw new Error("Overlay root not found");
    return;
  }

  return ReactDOM.createPortal(
    <Box
      sx={{
        alignItems: "center",
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        display: "flex",
        height: "100%",
        justifyContent: "center",
        left: 0,
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 1000,
      }}
    >
      <Box
        sx={{
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <CircularProgress size={48} />
        <Typography fontWeight={700} sx={{ mb: 0.5, mt: 2 }} variant="body1">
          {title}
        </Typography>
        <Typography variant="caption">{caption}</Typography>
      </Box>
    </Box>,
    overlayRoot,
  );
};

export default Overlay;
